<template>
    <textarea ref="codeTextareaRef" :class="$style.codeMirror" :value="props.code"></textarea>
</template>

<script lang="ts">
export default {
    name: 'Code'
};
</script>

<script lang="ts" setup>
import { ref, onMounted, onUnmounted, nextTick, watch } from 'vue';
import CodeMirror from 'codemirror/lib/codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/addon/lint/lint.css';

// import 'codemirror/addon/hint/html-hint.js';
import 'codemirror/mode/javascript/javascript.js';
import 'codemirror/mode/css/css.js';
// import 'codemirror/mode/htmlmixed/htmlmixed.js';
import 'codemirror/addon/lint/lint';
import 'codemirror/addon/lint/javascript-lint';
import 'codemirror/addon/lint/css-lint';
// import { JSHINT } from 'jshint';
// import { CSSLint } from 'csslint';
// (window as any).JSHINT = JSHINT;
// (<any>window).JSHINT = JSHINT;
// (<any>window).JSHINT = require('jshint').JSHINT;
// window.CSSLint = CSSLint;

// interface
interface Props {
    code: string;
    mode: string;
    options?: any;
}
// props
const props = defineProps<Props>();
// emits
const emit = defineEmits(['change']);
// state
const codeTextareaRef = ref();
let editorInstance: any = null; // codeMirror实例
// computed

// watch
watch(
    () => props.mode,
    () => {
        if (editorInstance) {
            init();
        }
    }
);

// onMounted
onMounted(() => {
    let defaultOptions = {
        mode: props.mode,
        value: props.code,
        theme: 'default',
        lineNumbers: true,
        indentWithTabs: true,
        smartIndent: true,
        matchBrackets: false,
        autofocus: true,
        // 当前选择行是否加亮
        styleActiveLine: true,
        // 长行时文字是否换行
        lineWrapping: true,
        // 默认情况下，CodeMirror会将使用相同class的两个span合并成一个
        flattenSpans: false,
        // 当前编辑器是否可用 true => 可用  false=> 不可用
        readOnly: false,
        gutters: ['CodeMirror-lint-markers'],
        lint: false
    };

    if (props.options) {
        defaultOptions = Object.assign(defaultOptions, props.options);
    }
    nextTick(() => {
        if (!editorInstance && codeTextareaRef.value) {
            editorInstance = CodeMirror.fromTextArea(codeTextareaRef.value, defaultOptions);
            editorInstance.on('change', function (cm) {
                const value = cm.getValue();
                emit('change', value);
            });
            init();
        }
        hanseResizeCodeMirror();
        window.addEventListener('resize', hanseResizeCodeMirror, false);
    });
});
// onUnmounted
onUnmounted(() => {
    window.removeEventListener('resize', hanseResizeCodeMirror, false);
});

/**
 * 改变codeMirror高度
 */
function hanseResizeCodeMirror() {
    if (editorInstance) {
        const parentElement = codeTextareaRef.value.parentElement;
        const height = parentElement.offsetHeight;
        editorInstance.setSize('100%', height);
    }
}

/**
 * codeMirror实例的值更新
 */
function init() {
    editorInstance.setOption('mode', props.mode);
    editorInstance.setValue(props.code);
    editorInstance.refresh();
}
</script>

<style lang="scss" module>
@import '@style/import.scss';
.codeMirror {
    height: 100%;
}
// :global {
//     .CodeMirror {
//         height: 100%;
//     }
// }
</style>
